import SearchSuggestion from './SearchSuggestion';

export default SearchSuggestion;
